import styled from "styled-components";
import {ContentBox} from "../../../components/UI";

export const Wrapper = styled(ContentBox)`
    padding: 20px;
`

export const Results = {
    Empty: styled.div`
        font-size: 14px;
        padding: 0 12px;
    `,
}